export default __webpack_public_path__ + "static/media/shell.f644e76d.png";